import './Resolution.css';
import Resolution from './Resolution';
export default Resolution;



// WEBPACK FOOTER //
// ./src/components/Game/components/Resolution/index.js